<template>
    <div>
      <vs-prompt
      @cancel="Canceld"
      @accept="Accepted"
      @close="Closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptAddObjectDebitorRoom"
      :is-valid="formValid">
       <div>
        <div>
          <p>{{$t('ADD_DEBITOROBJECT_ROOM.HEADER.TEXT')}}</p>
          <vs-divider>{{$t('ADD_DEBITOROBJECT_ROOM.DIVIDER.NAME')}}</vs-divider>
          <div class="default-input clearfix align-items-center mb-3">
            <vs-input :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.NAME')"  class="float-left mr-2 inputx" :placeholder="$t('ADD_DEBITOROBJECT_ROOM.LABEL.PLACEHOLDER.NAME')"  v-model="name"  :danger="name_fail" val-icon-danger="clear" />                           
          </div>
          <vs-divider>{{$t('ADD_DEBITOROBJECT_ROOM.DIVIDER.MASSE')}}</vs-divider>
          
          <!-- Eingabemodus Auswahl -->
          <div class="default-input clearfix align-items-center mb-3">
            <label class="vs-input--label" style="font-weight: bold;">{{$t('ADD_DEBITOROBJECT_ROOM.LABEL.INPUTMODE')}}</label>
            <div class="d-flex mt-2">
              <vs-radio v-model="inputMode" vs-value="3" class="mr-3">{{$t('ADD_DEBITOROBJECT_ROOM.LABEL.MODE_STANDARD')}}</vs-radio>
              <vs-radio v-model="inputMode" vs-value="1" class="mr-3">{{$t('ADD_DEBITOROBJECT_ROOM.LABEL.MODE_FLAECHE')}}</vs-radio>
              <vs-radio v-model="inputMode" vs-value="2">{{$t('ADD_DEBITOROBJECT_ROOM.LABEL.MODE_DACHSCHRAEGE')}}</vs-radio>
            </div>
          </div>

          <!-- Modus 1: Fläche als Ausgangspunkt -->
          <div v-if="inputMode === '1'">
            <div class="default-input d-flex align-items-center mb-3">
              <vs-input-number v-model="flaeche" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.FLAECHE')" step="0.5" class="inputx mr-2" />
              <vs-tooltip :text="$t('ADD_DEBITOROBJECT_ROOM.TOOLTIP.CALC_FROM_FLAECHE')">
                <vs-button size="small" color="primary" type="filled" icon="functions" class="ml-2" @click="CalcFromFlaeche()"></vs-button>
              </vs-tooltip>
            </div>
            <div class="default-input d-flex align-items-center mb-3">
              <vs-input-number v-model="length" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.LENGTH')" step="0.5" class="inputx mr-2" />
              <vs-input-number v-model="width" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.WIDTH')" step="0.5" class="inputx mr-2" />
              <vs-input-number v-model="height" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.HEIGHT')" step="0.5" class="inputx mr-2" />
              <vs-tooltip :text="$t('ADD_DEBITOROBJECT_ROOM.TOOLTIP.USE_DEFAULT_HEIGHT')">
                <vs-button size="small" color="success" type="filled" icon="check" class="ml-2" @click="UseDefaultHeight()"></vs-button>
              </vs-tooltip>
            </div>
            <div class="default-input d-flex align-items-center mb-3">
              <vs-input-number v-model="volume" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.VOL')" step="0.5" class="inputx" disabled />
            </div>
          </div>

          <!-- Modus 2: Dachschräge -->
          <div v-if="inputMode === '2'">
            <div class="default-input d-flex align-items-center mb-3">
              <vs-input-number v-model="flaeche" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.FLAECHE')" step="0.5" class="inputx mr-2" />
              <vs-input-number v-model="volume" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.VOL')" step="0.5" class="inputx" />
            </div>
            <div class="default-input d-flex align-items-center mb-3">
              <vs-input-number v-model="height" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.HEIGHT_AVG')" step="0.5" class="inputx mr-2" disabled />
              <vs-input-number v-model="length" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.LENGTH')" step="0.5" class="inputx mr-2" disabled />
              <vs-input-number v-model="width" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.WIDTH')" step="0.5" class="inputx" disabled />
            </div>
          </div>

          <!-- Modus 3: Standard -->
          <div v-if="inputMode === '3'">
            <div class="default-input d-flex align-items-center mb-3">
              <vs-input-number v-model="length" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.LENGTH')" step="0.5" class="inputx mr-2" />
              <vs-input-number v-model="width" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.WIDTH')" step="0.5" class="inputx mr-2" />
              <vs-input-number v-model="height" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.HEIGHT')" step="0.5" class="inputx mr-2" />
              <vs-tooltip :text="$t('ADD_DEBITOROBJECT_ROOM.TOOLTIP.USE_DEFAULT_HEIGHT')">
                <vs-button size="small" color="success" type="filled" icon="check" class="ml-2" @click="UseDefaultHeight()"></vs-button>
              </vs-tooltip>
            </div>
            <div class="default-input d-flex align-items-center mb-3">
              <vs-input-number v-model="flaeche" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.FLAECHE')" step="0.5" class="inputx mr-2" disabled />
              <vs-input-number v-model="volume" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.VOL')" step="0.5" class="inputx" disabled />
            </div>
          </div>          
          <vs-divider>{{$t('ADD_DEBITOROBJECT_ROOM.DIVIDER.WNDOWS_WALLS')}}</vs-divider>
          <div class="default-input clearfix align-items-center mb-3">
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.AUSSENW')" :type="ROOMAUSSEN" v-model="aussenwand"></InputSelectList>
            </div>
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.DECKE')" :type="ROOMDECKE" v-model="decke"></InputSelectList>
            </div>
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.BODEN')" :type="ROOMBODEN" v-model="boden"></InputSelectList>
            </div>
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.FENSTER')" :type="ROOMFENSTER" v-model="fenster"></InputSelectList>
            </div>
            <div class="float-left mr-2 mt-2" >
              <InputSelectList :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.INNENW')" :type="ROOMINNEN" v-model="innenwaende"></InputSelectList>
            </div>
          </div>
          <vs-textarea height="200px" counter="500" :label="$t('ADD_DEBITOROBJECT_ROOM.LABEL.BESCHREIBUNG')" :counter-danger.sync="description_fail" v-model="description" />
        </div>
       </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import InputSelectList from '../InputSelectList.vue';
import {inputSelectType} from '../../../helper/enumHelper';

export default {
  name: "AddDebitorObjectRoomDlg",
  props:['InitData'],
  components:{
    InputSelectList
  },
  data: function (){
     return {
      dlgActive: false,
      popupTitle: this.$t('ADD_DEBITOROBJECT_ROOM.TITLE'),
      inputMode: '3', // Standard-Modus
      id:0,
      name:"",
      description:"",
      length:0, 
      width:0, 
      flaeche:0,
      debitorobject_fk:0,
      height:0,
      defaultHeight:0,
      volume:0, 
      aussenwand:"", 
      decke:"", 
      boden:"", 
      fenster:"", 
      innenwaende:"",
      description_fail:false,
      name_ok:false,
      name_fail:false,
      updatingProgrammatically:false,
      ROOMAUSSEN: inputSelectType.ROOMAUSSEN,
      ROOMDECKE: inputSelectType.ROOMDECKE,
      ROOMBODEN: inputSelectType.ROOMBODEN,
      ROOMFENSTER: inputSelectType.ROOMFENSTER,
      ROOMINNEN: inputSelectType.ROOMINNEN
     }
  }, 
  mounted () {
    this.ClearForm();
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ShowDlg(id, defaultHeight){
        this.ClearForm();
        this.debitorobject_fk = id;
        this.defaultHeight = defaultHeight || 0;
        this.dlgActive = true;
      },
      Closed(){
        this.ClearForm();
      },
      InitDlgData(data, defaultHeight){
        
        this.defaultHeight = defaultHeight || 0;
        if(this.IsNotNull(data))
        {
          this.popupTitle = this.$t('ADD_DEBITOROBJECT_ROOM.TITLE.EDIT');
          this.id = data.id;
          this.name = data.name;
          this.description = data.description;
          this.width = data.width;
          this.length = data.length;
          this.flaeche = data.flaeche;
          this.debitorobject_fk = data.debitorobject_fk;
          this.height = data.height;
          this.volume = data.volume; 
          this.aussenwand = data.aussenwand; 
          this.decke = data.decke; 
          this.boden = data.boden; 
          this.fenster = data.fenster; 
          this.innenwaende = data.innenwaende;
          
          this.dlgActive=true;
        }
      },
      Accepted(){

         var name = this.name;

          var data = {
            id: this.id,
            name: this.name,
            description: this.description,
            length: Number(this.length), 
            width: Number(this.width), 
            flaeche: Number(this.flaeche),
            debitorobject_fk: this.debitorobject_fk,
            height: Number(this.height),
            volume: Number(this.volume), 
            aussenwand: this.aussenwand, 
            decke: this.decke, 
            boden: this.boden, 
            fenster: this.fenster, 
            innenwaende: this.innenwaende
          };

          this.$store.dispatch('debitorobject/saveDebitorObjectRoom', data)
          .then(response => {
            if(response.success === true)
            {
                this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('ADD_DEBITOROBJECT_ROOM.SUCCESS.SAVE').replace("*1*",name)});  
            }
            else
            {
              var text = this.$t('ADD_DEBITOROBJECT_ROOM.WARNING.SAVE').replace("*1*",name);
              text = text.replace("*2*",this.$t(response.text));
              this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
            }
            this.$emit('Accepted');
          }, 
          error =>{
              var text = this.$t('ADD_DEBITOROBJECT_ROOM.ERROR.SAVE').replace("*1*",name);
              text = text.replace("*2*",error);
              this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':text});  
              this.$emit('Accepted');
          });
          
          this.ClearForm();
      },
      Canceld(){
        this.ClearForm();
      },
      ClearForm(){
       
        this.popupTitle = this.$t('ADD_DEBITOROBJECT_ROOM.TITLE');

        this.id = 0;
        this.name = "";
        this.description = "";
        this.width = 0; 
        this.length = 0;
        this.flaeche = 0;
        this.debitorobject_fk = 0;
        this.height = 0;
        this.volume = 0; 
        this.aussenwand = ""; 
        this.decke = ""; 
        this.boden = ""; 
        this.fenster = ""; 
        this.innenwaende = "";
        this.name_ok = false;
        this.name_fail=false;
        this.inputMode = '3'; // Zurück zu Standard-Modus
        this.defaultHeight = 0;
      },
      CalcFromFlaeche(){
        // Berechne Länge und Breite aus Fläche (als Quadrat)
        if(Number(this.flaeche) > 0){
          var side = Math.sqrt(Number(this.flaeche));
          this.length = Number(side).toFixed(2);
          this.width = Number(side).toFixed(2);
        }
      },
      UseDefaultHeight(){
        // Setze die Default-Höhe vom DebitorObject
        if(Number(this.defaultHeight) > 0){
          this.height = Number(this.defaultHeight);
        }
      }
  },
  computed:{
    formValid(){
        // Name muss vorhanden sein
        return this.name_ok;
    }
  },
  watch:{
    // eslint-disable-next-line no-unused-vars
    inputMode(newMode){
      // Werte zurücksetzen beim Moduswechsel ist optional
      // Hier könnten wir bei Bedarf Werte löschen
    },
    length(value){
      if(value < 0) {
        this.length = 0;
      }
      
      if(this.updatingProgrammatically) return;
      
      if(this.inputMode === '3'){
        // Standard-Modus: Fläche berechnen wenn Breite vorhanden
        if(Number(value) > 0 && Number(this.width) > 0){
          this.flaeche = Number(Number(value) * Number(this.width)).toFixed(2);
          // Dann Volumen berechnen wenn Höhe vorhanden
          if(Number(this.height) > 0){
            this.volume = Number(Number(this.flaeche) * Number(this.height)).toFixed(2);
          }
        }
      } else if(this.inputMode === '1'){
        // Fläche als Ausgangspunkt: Breite anpassen damit Produkt = Fläche bleibt
        if(Number(value) > 0 && Number(this.flaeche) > 0){
          // Breite = Fläche ÷ Länge
          this.updatingProgrammatically = true;
          this.width = Number(Number(this.flaeche) / Number(value)).toFixed(2);
          this.updatingProgrammatically = false;
        }
      }
      // Modus 2: Länge ist disabled, keine Berechnung
    },
    width(value){
      if(value < 0) {
        this.width = 0;
      }
      
      if(this.updatingProgrammatically) return;
      
      if(this.inputMode === '3'){
        // Standard-Modus: Fläche berechnen wenn Länge vorhanden
        if(Number(this.length) > 0 && Number(value) > 0){
          this.flaeche = Number(Number(this.length) * Number(value)).toFixed(2);
          // Dann Volumen berechnen wenn Höhe vorhanden
          if(Number(this.height) > 0){
            this.volume = Number(Number(this.flaeche) * Number(this.height)).toFixed(2);
          }
        }
      } else if(this.inputMode === '1'){
        // Fläche als Ausgangspunkt: Länge anpassen damit Produkt = Fläche bleibt
        if(Number(value) > 0 && Number(this.flaeche) > 0){
          // Länge = Fläche ÷ Breite
          this.updatingProgrammatically = true;
          this.length = Number(Number(this.flaeche) / Number(value)).toFixed(2);
          this.updatingProgrammatically = false;
        }
      }
      // Modus 2: Breite ist disabled, keine Berechnung
    },
    flaeche(value){
      if(value < 0){
        this.flaeche = 0;
      }
      
      if(this.updatingProgrammatically) return;
      
      if(this.inputMode === '1'){
        // Flächen-Modus: Länge und Breite proportional anpassen (Verhältnis beibehalten)
        if(Number(value) > 0 && Number(this.length) > 0 && Number(this.width) > 0){
          // Skalierungsfaktor berechnen: neue Fläche / alte Fläche
          var oldFlaeche = Number(this.length) * Number(this.width);
          if(Number(oldFlaeche) > 0){
            var scaleFactor = Math.sqrt(Number(value) / Number(oldFlaeche));
            // Länge und Breite mit Wurzel des Faktors skalieren
            this.updatingProgrammatically = true;
            this.length = Number(Number(this.length) * scaleFactor).toFixed(2);
            this.width = Number(Number(this.width) * scaleFactor).toFixed(2);
            this.updatingProgrammatically = false;
          }
        }
        // Volumen berechnen wenn Höhe vorhanden
        if(Number(value) > 0 && Number(this.height) > 0){
          this.volume = Number(Number(value) * Number(this.height)).toFixed(2);
        }
      } else if(this.inputMode === '2'){
        // Dachschräge: Mittlere Höhe berechnen wenn Volumen vorhanden
        if(Number(value) > 0 && Number(this.volume) > 0){
          this.height = Number(Number(this.volume) / Number(value)).toFixed(2);
        }
        // Länge und Breite aus Wurzel der Fläche berechnen
        if(Number(value) > 0){
          var side = Math.sqrt(Number(value));
          this.updatingProgrammatically = true;
          this.length = Number(side).toFixed(2);
          this.width = Number(side).toFixed(2);
          this.updatingProgrammatically = false;
        }
      } else if(this.inputMode === '3'){
        // Standard-Modus: Volumen berechnen wenn Höhe vorhanden
        if(Number(value) > 0 && Number(this.height) > 0){
          this.volume = Number(Number(value) * Number(this.height)).toFixed(2);
        }
      }
    },
    height(value){
      if(value < 0) {
        this.height = 0;
      }
      
      if(this.inputMode === '1'){
        // Flächen-Modus: Volumen berechnen wenn Fläche vorhanden
        if(Number(this.flaeche) > 0 && Number(value) > 0){
          this.volume = Number(Number(this.flaeche) * Number(value)).toFixed(2);
        }
      } else if(this.inputMode === '3'){
        // Standard-Modus: Volumen berechnen wenn Fläche vorhanden
        if(Number(this.flaeche) > 0 && Number(value) > 0){
          this.volume = Number(Number(this.flaeche) * Number(value)).toFixed(2);
        }
      }
      // Modus 2: Höhe ist disabled (wird berechnet), kein Watcher nötig
    },
    volume(value){
      if(value < 0) {
        this.volume = 0;
      }
      
      if(this.inputMode === '2'){
        // Dachschräge: Mittlere Höhe berechnen wenn Fläche vorhanden
        if(Number(value) > 0 && Number(this.flaeche) > 0){
          this.height = Number(Number(value) / Number(this.flaeche)).toFixed(2);
        }
        // Länge und Breite aus Wurzel der Fläche berechnen (bei Volumenänderung)
        if(Number(this.flaeche) > 0){
          var side = Math.sqrt(Number(this.flaeche));
          this.updatingProgrammatically = true;
          this.length = Number(side).toFixed(2);
          this.width = Number(side).toFixed(2);
          this.updatingProgrammatically = false;
        }
      }
      // Modus 1 & 3: Volumen ist disabled, kein Watcher nötig
    },
    name(value)
    {
      this.name_fail = value.length == 0;
      this.name_ok = !this.name_fail;
    }
  }
};
</script>
<style>
div#promptAddObjectDebitorRoom > div.vs-dialog{
  max-width: 800px !important;
}
</style>